import apiTaxonomy from '@/modules/taxonomy/api';
import apiContent from '@/modules/content/api';

export default {
  namespaced: true,
  state: {
    current: null,
  },
  getters: {
    canReceiveContents(state): Boolean {
      return state.current !== null;
    },
  },
  actions: {
    async NAVIGATE_TO({ commit }, tag) {
      commit('SET_CURRENT', tag);
    },
    async CREATE_INTERNAL_TAG({ state }, name) {
      const payload = {
        name,
      };
      if (state.current) {
        Object.assign(payload, { parentId: state.current.id });
      }
      return apiTaxonomy.create(payload, 'internaltag');
    },
    async ADD_CONTENT({ state }, content) {
      if (!content
        || !state.current
        || !state.current.id) {
        return;
      }
      await apiContent.addInternalTag(content.id, state.current.id);
    },
    async DELETE_CONTENT({ state }, content) {
      if (!content
        || !state.current
        || !state.current.id) {
        return;
      }
      await apiContent.removeInternalTag(content.id, state.current.id);
    },
  },
  mutations: {
    SET_CURRENT: (state, tag) => {
      state.current = tag;
    },
  },
};
